<template>
    <div class="navbar custom-class"  style='height:32px;background-color:#fff'>
        <div v-if="layout.logo_show" class="logo">
          <img class="logo-img" :src="layout.img" alt="">
        </div>
        <div @click="bindGoSearch" class="navbar-action-wrap navbar-action-group row item-center" style='background-color:#F5F6F5;height:32px;flex: 1;margin-right: 10px;'>
            <div class="navbar-action_item">
                <span class="iconfont iconfangdajing" style="vertical-align: middle;"></span>
                <span style="color:#999999;padding:0 6px;font-size:12px">|</span>
                <span style="color:#999999;vertical-align: middle;font-size:12px">搜索</span>
            </div>
        </div>
        <div v-if="is_show_news" @click="bindGoNews" class="navbar-action-wrap navbar-action-group row item-center"
              style='background-color:#F5F6F5;height:32px;padding: 0 8px;color: #231815;'>
            <span class="iconfont iconxiaoxi1" style="position:relative">
                <badge_dot :is_show="!params.hasUnreadMessage" :size="6"></badge_dot>
            </span>
        </div>
        <div v-if="qrcode && qrcode.is_config && !qrcode.is_subscribe " @click="bindOpenQrShow" class="navbar-action-wrap navbar-action-group row item-center"
              style='margin-left:5px;background-color:#F5F6F5;height:32px;padding: 0 8px;color: #231815;'>
            <span class="iconfont iconerweima" > </span>
        </div>
        <van-popup class="qrshow" v-model="qrshow"   >
          <div class="qr_wrap">
            <div class="guide_desc">{{qrcode.wxaccount_desc}}</div>
            <img class="qr" :src="qrcode.wxaccount_qrcode" alt="">
            <div class="guide_op">长按识别或保存二维码</div>
            <div v-if="qrcode && qrcode.wxaccount_link" class="guide_link" @click="gotoFocusMp">点击关注公众号</div>
          </div>
        </van-popup>
    </div>
</template>

<script>
    import badge_dot from './badge_dot';
    import { Popup } from 'vant';
    export default {
        name: "navbar",
        components:{
            badge_dot,
            [Popup.name]:Popup,
        },
        props:{
            page_name:String,
            is_show_news:{
                type:Boolean,
                default:true
            },
            params:Object,
            layout:Object,
            qrcode:Object,
        },
        data(){
          return {
            'qrshow': false
          }
        },
        methods:{
            bindGoSearch(){
                this.$router.push(this.util.urlPrefix+'/search/index?token='+this.util.token)
            },
            bindGoNews(){
                this.$router.push(this.util.urlPrefix+'/news/index?token='+this.util.token)
            },
            bindOpenQrShow(){
              this.qrshow = true
            },
            gotoFocusMp(){
              //window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzMzc5NzA2Ng==#wechat_redirect'
              window.location.href = this.qrcode.wxaccount_link
            }
        }
    }
</script>

<style scoped>
    .logo{
      width: 170px;
    }
    .logo-img{
      height: 32px;
      max-width: 100%;
    }
    .navbar {
        width: 100%;
        overflow: hidden;
        /* position: relative; */
        /* top: 0; */
        /* left: 0; */
        /* z-index: 10; */
        flex-shrink: 0;
        /*margin-bottom: 10px;*/
        display: flex;
    }
    /* 这个navbar-title 没有作用 */
    .navbar-title {
        width: 100%;
        box-sizing: border-box;
        padding-left: 115px;
        padding-right: 115px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: absolute;
        left: 0;
        z-index: 10;
        color: #333;
        font-size: 16px;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .navbar-action-wrap {
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        /*position: absolute;*/
        /*left: 10px;*/
        z-index: 11;
        line-height: 1;
    }

    .navbar-action-group {
        /*border: 1px solid #f0f0f0;*/
        border-radius: 20px;
        overflow: hidden;
    }

    .navbar-action_item {
        padding: 3px 0;
        color: #333;
    }

    .navbar-action-group .navbar-action_item {
        padding: 0 12px;
    }

    .navbar-action-group .last {
        border-right: none;
    }
    .navbar-action-wrap .iconerweima{
      color: rgb(139, 139, 139);
    }
    .qrshow{
      height: 350px;
      width: 300px;
    }
    .qr_wrap{
      padding: 40px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .guide_desc{
      width: 200px;
      font-size: 14px;
      font-weight: 400;
      color: #626262;
      line-height: 24px;
      text-align: center;
    }
    .qr{
      width: 152px;
      height: 152px;
    }
    .guide_op{
      width: 250px;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #626262;
      line-height: 22px;
      text-align: center;
    }
    .guide_link{
      margin-top: 10px;
      font-size: 12px;
      color: #887cee;
    }
</style>
